<template lang="pug">
div
  .events--games-list-setting
    .events--games-list-setting-item.added
      select.form-control(v-model="searchParams.mygames" v-on:change="onChangeSearch" :disabled="searching || !canBringGames")
        option(value='') 自分の登録データ
        option(v-for="(key, name) in master.mygames_filter_options" :value="key")
          | {{name}}

    .events--games-list-setting-item.search
      select.form-control(v-model="searchParams.players" v-on:change="onChangeSearch" :disabled="searching")
        option(value='') プレイ人数
        option(v-for="(key, name) in master.players_filter_options" :value="key")
          | {{name}}
    .events--games-list-setting-item.search
      select.form-control(v-model="searchParams.playtimes" v-on:change="onChangeSearch" :disabled="searching")
        option(value='') プレイ時間
        option(v-for="(key, name) in master.playtimes_filter_options" :value="key")
          | {{name}}
    .events--games-list-setting-item.sort
      select.form-control(v-model="searchParams.sort" v-on:change="onChangeSearch" :disabled="searching")
        option(value='') 並び替え
        optgroup(v-for="(options, name) in master.order_options" :label="name")
          option(v-for="(key, name) in options" :value="key")
            | {{name}}
    .events--games-list-setting-item.edit(v-if="canBringGames")
      a.btn.btn-primary(
        v-bind:href="candidates_path"
        rel: "noopener nofollow"
      )
        | <span class="visible-xs">持っていくゲームを</span>登録する

  .events--games-list.list--games
    ul
      li.game.col-lg-6.col-md-6.col-sm-4.col-xs-12(v-for="game in games" :key="game.id")
        a.link.short(
          v-bind:href="game.show_path"
          :style="linkStyle(game.large_thumb_path)"
          target="_blank"
        )
          .names.short
            .jp {{game.name}}
            .users
              .item(v-for='user in game.bringing_users')
                img(
                  :src="user.publish_image_url"
                  :alt="user.nickname"
                  width="100"
                  height="100"
                )
                span {{user.nickname}}さん
        .data
          .players
            i.fa.fa-users.font-awesome-icon
            | {{game.players_range_text}}
          .playtime
            i.fa.fa-clock.font-awesome-icon
            | {{game.playtime_range_text}}
          .agefor
            i.fa.fa-child.font-awesome-icon
            | {{game.decorated_for_age}}
          .publication
            i.fa.fa-calendar.font-awesome-icon
            | {{game.decorated_publication_date}}

        .introduction
          .text(v-if="game.catchcopy")
            p.catchcopy
              | {{game.catchcopy}}
            p.catchtext(v-if="game.truncated_lead")
              | {{game.truncated_lead}}
          .text.empty(v-else)
            p.catchtext 作品説明文が未投稿のゲームです

          .myboardgame
            .status.watching
              .user(v-for="user in game.watching_users") {{user.nickname}}
            .status.favorite
              .user(v-for="user in game.favorite_users") {{user.nickname}}

        ul.actions
          li.col-lg-3.col-md-3.col-sm-3.col-xs-3
            a.interest.available.watching(
              v-if="game.can_change_interest"
              v-on:click="onClickChangeInterest(game, 'watching')"
              :class="game.interest.watching ? 'on' : 'off'"
            )
              i.fa.fa-bell.font-awesome-icon
              var {{game.interests_watching_count}}
              em 興味あり
            span.watching(v-else)
              i.fa.fa-bell.font-awesome-icon
              var {{game.interests_watching_count}}
              em 興味あり

          li.col-lg-3.col-md-3.col-sm-3.col-xs-3
            a.interest.available.played(
              v-if="game.can_change_interest"
              v-on:click="onClickChangeInterest(game, 'played')"
              :class="game.interest.played ? 'on' : 'off'"
            )
              i.fa.fa-thumbs-up.font-awesome-icon
              var {{game.interests_play_count}}
              em 経験あり
            span.played(v-else)
              i.fa.fa-thumbs-up.font-awesome-icon
              var {{game.interests_play_count}}
              em 経験あり

          li.col-lg-3.col-md-3.col-sm-3.col-xs-3
            a.interest.available.favorite(
              v-if="game.can_change_interest"
              v-on:click="onClickChangeInterest(game, 'favorite')"
              :class="game.interest.favorite ? 'on' : 'off'"
            )
              i.fa.fa-heart.font-awesome-icon
              var {{game.interests_favorite_count}}
              em お気に入り
            span.favorite(v-else)
              i.fa.fa-heart.font-awesome-icon
              var {{game.interests_favorite_count}}
              em お気に入り

          li.col-lg-3.col-md-3.col-sm-3.col-xs-3
            a.interest.available.have(
              v-if="game.can_change_interest"
              v-on:click="onClickChangeInterest(game, 'have')"
              :class="game.interest.have ? 'on' : 'off'"
            )
              i.fa.fa-star.font-awesome-icon
              var {{game.interests_have_count}}
              em 持ってる
            span.have(v-else)
              i.fa.fa-star.font-awesome-icon
              var {{game.interests_have_count}}
              em 持ってる

  infinite-loading(spinner="waveDots" @infinite="infiniteHandler" :key="infiniteId")
    span(slot="no-results")
    span(slot="no-more")
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import axios from 'common/axios';

export default {
  components: { InfiniteLoading },
  props: {
    eventId: {
      type: Number,
      default: 0
    },
    master: {
      type: Object,
      default: () => ({})
    },
    canBringGames: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      games: [],
      page: 1,
      infiniteId: +new Date(),
      searching: false,
      searchParams: {
        mygames: '',
        players: '',
        playtimes: '',
        sort: ''
      }
    };
  },
  computed: {
    gamesIndexPath: function(){
      return '/events/' + this.eventId + '/games';
    },
    candidates_path: function() {
      return '/events/' + this.eventId + '/games/candidates';
    }
  },
  methods: {
    onClickChangeInterest: function(game, action) {
      let self = this;
      axios.get('/mypage/ajax_mygame_create_and_invert_interest', {
        params: {
          ajax_handler: 'handle_mygame_create_and_invert_interest',
          game_id: game.id,
          interest: action
        },
      }).then(function(){
        self.onChangeSearch();
      });
    },
    linkStyle: function(path) {
      return 'background-image: url("' + path + '")';
    },
    infiniteHandler: function($state) {
      axios.get(this.gamesIndexPath, {
        params: {
          page: this.page,
          ...this.searchParams
        },
      }).then(({ data }) => {
        if (data.games.length) {
          this.page += 1;
          this.games.push(...data.games);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    onChangeSearch: function() {
      let self = this;

      self.searching = true;
      axios.get(this.gamesIndexPath, { params: self.searchParams }).then(function(response) {
        const data = response.data;
        self.games = data.games;
        self.searching = false;
        // NOTE: 検索で1ページ目を取得しているので、infiniteHandlerで重複しないようにpageを2にしておく
        self.page = 2;
        self.infiniteId++;
      });
    },

  }
};
</script>
